/**
 * QuickBooks API client — v4
 */

import { apiFetch } from './client'

export interface QBStatus {
  connected: boolean
  needs_reconnect?: boolean
  company_name?: string
  sandbox?: boolean
  environment?: string
  last_sync_at?: string
  connection_status?: string
  last_error?: string | null
  qb_auto_sync?: boolean
}

export interface QBSyncError {
  local_entity_type: string
  local_entity_id: number
  qb_entity_type: string
  last_error: string | null
  last_error_at: string | null
}

export async function loadQBStatus(): Promise<QBStatus> {
  return apiFetch<QBStatus>('GET', '/api/quickbooks/status')
}

export async function getQBConnectUrl(): Promise<{ url: string; state: string }> {
  return apiFetch<{ url: string; state: string }>('GET', '/api/quickbooks/connect')
}

export async function disconnectQB(): Promise<{ success: boolean }> {
  return apiFetch<{ success: boolean }>('POST', '/api/quickbooks/disconnect')
}

export async function syncProjectToQB(projectId: number): Promise<unknown> {
  return apiFetch('POST', `/api/quickbooks/sync/${projectId}`)
}

export async function fetchQBSyncErrors(): Promise<QBSyncError[]> {
  const res = await apiFetch<{ data: QBSyncError[] }>('GET', '/api/quickbooks/sync-errors')
  return res.data ?? []
}

export async function saveQbAutoSync(enabled: boolean): Promise<void> {
  await apiFetch('POST', '/api/settings', { qb_preferences: { qb_auto_sync: enabled } })
}

/** Start OAuth — caller redirects window.location.href = url */
export async function startQBConnect(): Promise<string> {
  const { url } = await getQBConnectUrl()
  return url
}
